// Hook: DELETE /company/users/{userId}

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

type IResponse = ICommandResponseSuccess;

const deleteCompanyUser = (userId: number): Promise<IResponse> =>
  axios.delete(`/company/users/${userId}`);

export const useDeleteCompanyUser = (
  options?: UseMutationOptions<IResponse, IError, number>
) => useMutation((userId: number) => deleteCompanyUser(userId), options);
